export default __webpack_public_path__ + "4b27c6bb787a0c327216a29e352ac983.png";